<app-keycom-container
  *ngIf="user"
  logo="assets/images/ovt-logo.svg"
  [title]="title"
  [user]="user"
  (helpAction)="helpAction($event)"
  (profileAction)="profileAction($event)"
>
  <!-- Top Bar -->
  <div class="row padding top all">
    <div>
      <app-bread-crumbs></app-bread-crumbs>
    </div>
    <div class="queue-for-mecs">
      <span
        class="margin right"
        [matTooltip]="disableMecsBtn ? mecsToolTipMessage : null"
        style="display: inline-flex"
      >
        <button
          mat-stroked-button
          color="accent"
          (click)="queueForValidation()"
          [disabled]="disableMecsBtn"
          style="font-size: 14px; letter-spacing: -0.1px; text-transform: none; font-weight: 400; width: 155px; min-width: 155px"
        >
          <mat-icon *ngIf="disableMecsBtn" class="mecs-btn-tooltip padding right">warning_outline</mat-icon>
          <mat-icon *ngIf="!disableMecsBtn" style="font-size: 14px; width: 14px; height: 14px; margin-right: 4px; color: #b9bec6">fact_check</mat-icon>
          Queue for MECS
        </button>
      </span>
    </div>
  </div>

  <!-- App System Bar -->
  <app-system-top-bar
    [structure]="structure"
    [keySystem]="keySystem"
    [keySystemDataSets]="keySystemDataSets"
    [keywayFamily]="keywayFamily"
    [combinatingRule]="combinatingRule"
  >
  </app-system-top-bar>

  <!-- App -->
  <router-outlet></router-outlet>
</app-keycom-container>
